module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAkCAYAAADckvn+AAAAaElEQVRYhe3ZsQ3AIAwFUTvy/is7TTICQvd1r6HlZBqL3t2tXP3cvsFp8YFTVX37EifFT9BAOgPpDKQzkM5AuvjA+c7YnTB+gvGB/xON3QnjJ2ggnYF0BtIZSGcgnYF0U8HLbvkBGuAFhpsGTvAFQKwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2019_firefly_TerWeb/0/menu icon.png
// module id = 2vlL
// module chunks = 1